import React, { useEffect, useRef, useState, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CommonNav from "../../../CommonNav";
import Loading from "../../../../lib/Loading";
import Footer from "../../../Footer";

import UploadImageToS3WithPhp from "../../../../lib/UploadImageToS3WithPhp";
import BuddibleSocket, { MsgIDList } from "../../../../lib/BuddibleSocket";
import Utilities from "../../../../lib/Utilities";
import CodeList from "../../../../lib/CodeList";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "ReserveFCL";

const times = [
  "00:00",
  "00:10",
  "00:20",
  "00:30",
  "00:40",
  "00:50",
  "01:00",
  "01:10",
  "01:20",
  "01:30",
  "01:40",
  "01:50",
  "02:00",
  "02:10",
  "02:20",
  "02:30",
  "02:40",
  "02:50",
  "03:00",
  "03:10",
  "03:20",
  "03:30",
  "03:40",
  "03:50",
  "04:00",
  "04:10",
  "04:20",
  "04:30",
  "04:40",
  "04:50",
  "05:00",
  "05:10",
  "05:20",
  "05:30",
  "05:40",
  "05:50",
  "06:00",
  "06:10",
  "06:20",
  "06:30",
  "06:40",
  "06:50",
  "07:00",
  "07:10",
  "07:20",
  "07:30",
  "07:40",
  "07:50",
  "08:00",
  "08:10",
  "08:20",
  "08:30",
  "08:40",
  "08:50",
  "09:00",
  "09:10",
  "09:20",
  "09:30",
  "09:40",
  "09:50",
  "10:00",
  "10:10",
  "10:20",
  "10:30",
  "10:40",
  "10:50",
  "11:00",
  "11:10",
  "11:20",
  "11:30",
  "11:40",
  "11:50",
  "12:00",
  "12:10",
  "12:20",
  "12:30",
  "12:40",
  "12:50",
  "13:00",
  "13:10",
  "13:20",
  "13:30",
  "13:40",
  "13:50",
  "14:00",
  "14:10",
  "14:20",
  "14:30",
  "14:40",
  "14:50",
  "15:00",
  "15:10",
  "15:20",
  "15:30",
  "15:40",
  "15:50",
  "16:00",
  "16:10",
  "16:20",
  "16:30",
  "16:40",
  "16:50",
  "17:00",
  "17:10",
  "17:20",
  "17:30",
  "17:40",
  "17:50",
  "18:00",
  "18:10",
  "18:20",
  "18:30",
  "18:40",
  "18:50",
  "19:00",
  "19:10",
  "19:20",
  "19:30",
  "19:40",
  "19:50",
  "20:00",
  "20:10",
  "20:20",
  "20:30",
  "20:40",
  "20:50",
  "21:00",
  "21:10",
  "21:20",
  "21:30",
  "21:40",
  "21:50",
  "22:00",
  "22:10",
  "22:20",
  "22:30",
  "22:40",
  "22:50",
  "23:00",
  "23:10",
  "23:20",
  "23:30",
  "23:40",
  "23:50",
];
const sfc_TYPE = {
  "": "",
  DC: "Dry",
  RF: "Reefer",
  TC: "Tank",
  OT: "Open Top",
  FR: "Flat Rack",
};
const sfc_SIZE = {
  "": "",
  20: "20`",
  40: "40`",
  "4H": "40`HQ",
  45: "45`",
};

let loginInfo = null;
let schedule_data = null;
let container_files = [];
let memo_files = [];
let reefer_count = 0;
let oug_count = 0;
let dgNoteActive = 0;
let flexiBagActive = 0;
let note_modal_data = {
  title: "",
  desc: "",
};

let sbf_BOOK_UID = "";

export default function ReserveFCL(props) {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [isSuccessGetData, setIsSuccessGetData] = useState(false);
  const [sbf_TRAN_TYPE, setTransitType] = useState("LINE");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [container_detail_list, setContainer_detail_list] = useState([]);
  const [container_detail_list_OG, setContainer_detail_list_OG] = useState([]);
  const [pickPlace, setPickPlace] = useState([]);
  const cfs_data = { ...location.state };

  const $controller = {
    sbf_SHIPPER: useRef(), //SHIPPER
    sbf_COMP_NM: useRef(), //실화주

    sbf_USER_NAME: useRef(), //부킹담당자 이름
    sbf_BOOK_TEL: useRef(), //부킹담당자 전화번호
    sbf_BOOK_MOBILE: useRef(), //부킹담당자 휴대전화
    sbf_USER_ID: useRef(), //부킹담당자 이메일
    sbf_BOOK_FAX: useRef(), //부킹담당자 팩스

    sbf_DOC_USER_NAME: useRef(), //서류담당자 이름
    sbf_DOC_USER_TEL: useRef(), //서류담당자 전화번호
    sbf_DOC_USER_MOBILE: useRef(), //서류담당자 휴대전화
    sbf_DOC_USER_ID: useRef(), //서류담당자 이메일
    sbf_DOC_USER_FAX: useRef(), //서류담당자 팩스

    sbf_WEIGHT_CNT: useRef(), //화물 무게
    sbf_WEIGHT_TYPE: useRef(), //화물 무게 구분

    sbf_TRAN_TYPE: useRef(), // 운송조건 구분
    sbf_TRAN_FREIGHT: useRef(), //운송조건 Freight
    sbf_TRAN_FREIGHT_SCNO: useRef(), //운송조건 SC No.
    sbf_TRAN_TERM: useRef(), //운송조건 SC No.

    sbf_PICK_DATE: useRef(), //픽업날자
    sbf_PICK_TIME: useRef(), //픽업 시간
    sbf_PICK_PLACE: useRef(), //픽업위치
    sbf_PICK_USER_NM: useRef(), //픽업 담당자 이름
    sbf_PICK_USER_TEL: useRef(), //픽업 담당자 연락처
    sbf_PICK_MEMO: useRef(), // 픽업 요청 메모

    sbf_FACT_DATE: useRef(), //공장 작업일자
    sbf_FACT_TIME: useRef(), //공장 작업 시간
    sbf_FACT_PLACE: useRef(), //공장 작업장소
    sbf_FACT_USER_NM: useRef(), //공장 담당자 이름
    sbf_FACT_USER_TEL: useRef(), //공장 담당자 연락처
    sbf_FACT_MEMO: useRef(), //공장 요청 메모

    sbf_CFS_DATE: useRef(), //입고 날짜
    sbf_CFS_TIME: useRef(), //입고 시간
    sbf_CFS_PLACE: useRef(), // 입고 CFS
    sbf_CFS_MEMO: useRef(), //입고 요청사항

    sbf_ETC_PRODUCT: useRef(), //영문명
    sbf_ETC_RTN_YN: useRef(), //반송화물 보세운송조건
    sbf_ETC_MEMO: useRef(), //요청사항
  };

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
    SELECT_PICK_PLACE();
    sbf_BOOK_UID = util.makeUUIDv4();
    if (sbf_BOOK_UID !== "") {
      setContainer_detail_list([
        {
          id: util.makeUUIDv4(),
          sfc_BOOK_UID: sbf_BOOK_UID,
          sfc_MAIN_TYPE: "M", //컨테이너 타입
          sfc_SIZE: "", //컨테이너 사이즈
          sfc_TYPE: "", //컨테이너 추가정보 타입
          sfc_CNT: "", // 수량
          sfc_MAKER_YN: "", // 화주컨테이너 YN
          sfc_DANGER_YN: "", //위험화물 YN
          sfc_EMPTY_YN: "", //empty YN
          sfc_FLEXI_YN: "", // Flexi-Bag YN
          sfc_TEMPERATURE: "", //냉동 컨테이너 추가정보 온도
          sfc_FAN_OPEN_PER: "", //냉동 컨테이너 추가정보 환풍기 OPEN
          sfc_LENGTH: "", //OUG 사이즈
          sfc_WIDTH: "", //OUG 사이즈
          sfc_HEIGHT: "", //OUG 사이즈
          sfc_VOID: "", //OUG 사이즈
          sfc_WEIGHT: "", //OUG 사이즈
          sfc_MEMO: "", // 컨테이너 메모
        },
      ]);
    }

    const userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData && userData["returnData"].length) {
      loginInfo = userData["returnData"][0];
      SELECT_SCHEDULE_DATA();
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (!n) {
          codeList.Modal.current.alert(t("commonMSG.requiresLogin"), () => {
            window.location.replace();
          });
        }
        loginInfo = n["returnData"][0];
        SELECT_SCHEDULE_DATA();
      }
    );

    socket.addLocalEventListener(
      MsgIDList.EVENT_SOCKET_DATA_ERROR,
      _mClassName,
      (b, n) => {
        console.log("데이터 통신에러", n);
      }
    );

    return () => {
      loginInfo = null;
      schedule_data = null;
      container_files = [];
      memo_files = [];
      reefer_count = 0;
      oug_count = 0;
      dgNoteActive = 0;
      flexiBagActive = 0;

      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );

      socket.removeLocalEventListener(
        MsgIDList.EVENT_SOCKET_DATA_ERROR,
        _mClassName
      );
    };
  }, []);

  function SELECT_PICK_PLACE() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/pick_place/JS_pick_place_select.php",
      msgID: msgID,
      data: {},
      ppUseYN: "Y",
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          let data = [...newData["returnData"]];
          setPickPlace(data);
        }
      }
    });
  }

  //스케쥴 정보 가져오기
  function SELECT_SCHEDULE_DATA() {
    const sm_IDX = params.hasOwnProperty("id") ? params.id : "";

    if (sm_IDX === "") {
      codeList.Modal.current.alert(t("commonMSG.invalidAccess"));
      window.history.back();
    }

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_select.php",
      msgID: msgID,
      data: {},
      sm_IDX: sm_IDX,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          if (newData["returnData"].length > 0) {
            schedule_data = newData["returnData"][0];
            setIsSuccessGetData(true);
          } else {
            codeList.Modal.current.alert(t("commonMSG.invalidAccess"), () => {
              window.history.back();
            });
          }
        } else {
          codeList.Modal.current.alert(t("commonMSG.error"));
        }
      }
    });
  }

  //SHIPPER와 실화주 동일
  function copyShipperComp() {
    $controller.sbf_COMP_NM.current.value =
      $controller.sbf_SHIPPER.current.value;
    setIsNeedUpdate(!isNeedUpdate);
  }

  //부킹 담당자 동일
  function copyEmployeeInfo() {
    $controller.sbf_DOC_USER_NAME.current.value =
      $controller.sbf_USER_NAME.current.value;
    $controller.sbf_DOC_USER_TEL.current.value =
      $controller.sbf_BOOK_TEL.current.value;

    $controller.sbf_DOC_USER_MOBILE.current.value =
      $controller.sbf_BOOK_MOBILE.current.value;
    $controller.sbf_DOC_USER_ID.current.value =
      $controller.sbf_USER_ID.current.value;
    $controller.sbf_DOC_USER_FAX.current.value =
      $controller.sbf_BOOK_FAX.current.value;

    setIsNeedUpdate(!isNeedUpdate);
  }

  //담당자 연결
  function requestEnquiry(enquiryType) {
    let typeText = t("schedule.fcl.reserveNamsung.salse");
    if (enquiryType === 1) {
      typeText = t("schedule.fcl.reserveNamsung.salse");
    }
    if (!loginInfo) {
      codeList.Modal.current.alert(t("commonMSG.requiresLogin"));
      return;
    }
    codeList.Modal.current.confirm(
      `${t("schedule.fcl.reserveNamsung.msg.inquiryToEmpPrev")}${typeText}${t(
        "schedule.fcl.reserveNamsung.msg.inquiryToEmpNext"
      )}`,
      (ret) => {
        if (ret) {
          localStorage.setItem("enquiryManager", "Z0001|hskim@gbts.co.kr");
          window.open("/LogiTalk", "LogiTalk", "_blank");
        }
      }
    );
  }

  //컨테이너 정보 첨부파일 업로드
  function uploadContainerFile(val) {
    if (!val.ret) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.errorUploadFile")
      );
      return;
    }
    let dataList = [...container_files];
    //파일명?파일주소
    dataList.push(`${val.realFileName}?${val.fileName}`);
    container_files = dataList;
    setIsNeedUpdate(!isNeedUpdate);
  }

  //컨테이너 정보 첨부파일 삭제
  function deleteContainerFile(index) {
    container_files.splice(index, 1);
    setIsNeedUpdate(!isNeedUpdate);
  }

  //컨테이너 정보 첨부파일 업로드
  function uploadAddMemoFile(val) {
    if (!val.ret) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.errorUploadFile")
      );
      return;
    }
    let dataList = [...memo_files];
    //파일명?파일주소
    dataList.push(`${val.realFileName}?${val.fileName}`);
    memo_files = dataList;
    setIsNeedUpdate(!isNeedUpdate);
  }

  //컨테이너 추가
  const addContainerInfo = (type = "M") => {
    let data = [
      ...container_detail_list,
      {
        id: util.makeUUIDv4(),
        sfc_BOOK_UID: sbf_BOOK_UID,
        sfc_MAIN_TYPE: type, //컨테이너 타입
        sfc_SIZE: "", //컨테이너 사이즈
        sfc_TYPE: "", //컨테이너 추가정보 타입
        sfc_CNT: "", // 수량
        sfc_MAKER_YN: "", // 화주컨테이너 YN
        sfc_DANGER_YN: "", //위험화물 YN
        sfc_EMPTY_YN: "", //empty YN
        sfc_FLEXI_YN: "", // Flexi-Bag YN
        sfc_TEMPERATURE: "", //냉동 컨테이너 추가정보 온도
        sfc_FAN_OPEN_PER: "", //냉동 컨테이너 추가정보 환풍기 OPEN
        sfc_LENGTH: "", //OUG 사이즈
        sfc_WIDTH: "", //OUG 사이즈
        sfc_HEIGHT: "", //OUG 사이즈
        sfc_VOID: "", //OUG 사이즈
        sfc_WEIGHT: "", //OUG 사이즈
        sfc_MEMO: "", // 컨테이너 메모
      },
    ];
    setContainer_detail_list(data);
  };

  //컨테이너 삭제
  function deleteContainerInfo(index) {
    if (container_detail_list.length === 1) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.requiresContainer")
      );
      return;
    }
    let _container_detail_list = [...container_detail_list];
    _container_detail_list.splice(index, 1);

    if (reefer_count) {
      reefer_count =
        _container_detail_list.filter((item) => item.sfc_MAIN_TYPE === "R")
          .length > 0;
    }
    if (oug_count) {
      oug_count =
        _container_detail_list.filter((item) => item.sfc_MAIN_TYPE === "O")
          .length > 0;
    }
    setContainer_detail_list(_container_detail_list);
  }

  //컨테이너 데이터 변경
  function changeContainerDetailData(index, key, value) {
    // ※DRY/ REEFER/ TANK/ OPT, FRK 동시에 선택 불가

    // DRY, REEFER, TANK, OPT, FRK 는 동일 사이즈 추가 불가 QTY로만 조정
    // REEFER는 20, 40HQ 사이즈만 존재함

    // OPT, FRK는 컨테이너 수량별로 detail정보가 필요
    // OPT, FRK는 size 변경시 상세 정보 자동변경 필요

    // Dry, Reefer, Tank, OpenTop, FlatRack

    //container_detail_list[index][key] = value;
    /*
    DC - Dry
    RF - Reefer
    TC - Tank
    OT - Open Top
    FR - Flat Rack
    */

    let _container_detail_list = [...container_detail_list];

    _container_detail_list[index][key] = value;
    if (_container_detail_list.length > 1) {
      // 행이 1개이상일 경우 비교
      // ※DRY/ REEFER/ TANK/ OPT, FRK 동시에 선택 불가 검사
      if (key === "sfc_TYPE") {
        //타입 변경시
        let beforeType = "";

        for (let i = 0; i < _container_detail_list.length; i++) {
          if (i !== index) {
            //이전 선택 컨테이너타입 변수 저장
            if (beforeType === "") {
              beforeType = _container_detail_list[i]["sfc_TYPE"];
              break;
            }
          }
        }

        if (beforeType !== "") {
          //이전에 선택된 컨테이너 타입이 있을경우
          let currentType = _container_detail_list[index]["sfc_TYPE"];
          if (beforeType !== currentType) {
            //이전 컨테이너와 타입이 다른 경우
            if (
              !(
                (beforeType === "OT" || beforeType === "FR") &&
                (currentType === "OT" || currentType === "FR")
              )
            ) {
              // 이전 컨테이너와 타입이 다르면서 OT와 FR혼용이 아닌경우 선택 취소
              codeList.Modal.current.alert(
                `[${sfc_TYPE[currentType]}] ${t(
                  "schedule.fcl.reserveNamsung.msg.impossibilityDifferentContainer"
                )}`
              );
              _container_detail_list[index][key] = "";
              setContainer_detail_list([..._container_detail_list]);
              return;
            }
          }
        }

        //컨테이너 타입 유효성 모두 검수 끝난경우
        //_container_detail_list[index][key] = value;
      }
    }

    //사이즈 유효성 검사
    // REEFER는 20, 40HQ 사이즈만 존재함
    // FR, OP는 20, 40 사이즈만 존재함
    let currentType = _container_detail_list[index]["sfc_TYPE"];
    let currentSize = _container_detail_list[index]["sfc_SIZE"];
    if (currentSize !== "") {
      if (currentType === "RF" && currentSize === "40") {
        codeList.Modal.current.alert(
          `[${sfc_TYPE[currentType]}]${t(
            "schedule.fcl.reserveNamsung.msg.no40Size"
          )}`
        );
        _container_detail_list[index]["sfc_SIZE"] = "4H";
        //setContainer_detail_list([..._container_detail_list]);
      }
      if (
        (currentType === "OT" || currentType === "FR") &&
        currentSize === "4H"
      ) {
        codeList.Modal.current.alert(
          `[${sfc_TYPE[currentType]}]${t(
            "schedule.fcl.reserveNamsung.msg.no40HQSize"
          )}`
        );
        _container_detail_list[index]["sfc_SIZE"] = "40";
        //setContainer_detail_list([..._container_detail_list]);
      }
    }

    //사이즈 변경시
    // DRY, REEFER, TANK, OPT, FRK 는 동일 사이즈 추가 불가 QTY로만 조정
    if (_container_detail_list.length > 1) {
      let sizeList = {};
      for (let i = 0; i < _container_detail_list.length; i++) {
        if (i !== index) {
          //이전 선택 컨테이너사이즈 변수 저장
          // OT와 FR은 중복 사이즈가 가능하기때문에 TYPE도 키값에 추가
          sizeList[
            _container_detail_list[i]["sfc_TYPE"] +
              _container_detail_list[i]["sfc_SIZE"]
          ] = true;
        }
      }
      if (
        sizeList.hasOwnProperty(
          _container_detail_list[index]["sfc_TYPE"] +
            _container_detail_list[index]["sfc_SIZE"]
        )
      ) {
        //중복 타입의 중복 사이즈가 있는경우 선택 취소
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.duplicateContainerSize")
        );
        _container_detail_list[index]["sfc_SIZE"] = "";
        setContainer_detail_list([..._container_detail_list]);
        return;
      }
    }
    remakeOGData();
    setContainer_detail_list(_container_detail_list);

    reefer_count =
      _container_detail_list.filter((item) => item.sfc_TYPE === "RF").length >
      0;
    oug_count =
      _container_detail_list.filter(
        (item) => item.sfc_TYPE === "OT" || item.sfc_TYPE === "FR"
      ).length > 0;
  }

  //OG 컨테이너 행 개수 컨트롤
  function remakeOGData() {
    //container_detail_list_OG
    let _container_detail_list = [...container_detail_list];
    let _container_detail_list_OG = [...container_detail_list_OG];
    let totalOG = 0;
    for (let i = 0; i < _container_detail_list.length; i++) {
      if (
        _container_detail_list[i]["sfc_TYPE"] === "OT" ||
        _container_detail_list[i]["sfc_TYPE"] === "FR"
      ) {
        totalOG += parseInt(_container_detail_list[i]["sfc_CNT"], 0);
      }
    }

    if (_container_detail_list_OG.length > totalOG) {
      _container_detail_list_OG.splice(totalOG - 1);
    }
    if (_container_detail_list_OG.length < totalOG) {
      let addCount = totalOG - _container_detail_list_OG.length;
      for (let i = 0; i < addCount; i++) {
        _container_detail_list_OG.push({
          id: util.makeUUIDv4(),
          sfc_BOOK_UID: sbf_BOOK_UID,
          sfc_MAIN_TYPE: "O", //컨테이너 타입
          sfc_SIZE: "", //컨테이너 사이즈
          sfc_TYPE: "", //컨테이너 추가정보 타입
          sfc_CNT: "", // 수량
          sfc_MAKER_YN: "", // 화주컨테이너 YN
          sfc_DANGER_YN: "", //위험화물 YN
          sfc_EMPTY_YN: "", //empty YN
          sfc_FLEXI_YN: "", // Flexi-Bag YN
          sfc_TEMPERATURE: "", //냉동 컨테이너 추가정보 온도
          sfc_FAN_OPEN_PER: "", //냉동 컨테이너 추가정보 환풍기 OPEN
          sfc_LENGTH: "", //OUG 사이즈
          sfc_WIDTH: "", //OUG 사이즈
          sfc_HEIGHT: "", //OUG 사이즈
          sfc_VOID: "", //OUG 사이즈
          sfc_WEIGHT: "", //OUG 사이즈
          sfc_MEMO: "", // 컨테이너 메모
        });
      }
    }

    let increaseCnt = 0;
    for (let i = 0; i < _container_detail_list.length; i++) {
      if (
        _container_detail_list[i]["sfc_TYPE"] === "OT" ||
        _container_detail_list[i]["sfc_TYPE"] === "FR"
      ) {
        let addCount = 0;

        addCount = parseInt(_container_detail_list[i]["sfc_CNT"], 0);

        if (addCount > 0) {
          for (let j = increaseCnt; j < increaseCnt + addCount; j++) {
            _container_detail_list_OG[j]["sfc_TYPE"] =
              _container_detail_list[i]["sfc_TYPE"];
            _container_detail_list_OG[j]["sfc_SIZE"] =
              _container_detail_list[i]["sfc_SIZE"];
          }
          increaseCnt += addCount;
        }
      }
    }

    setContainer_detail_list_OG(_container_detail_list_OG);
  }

  //컨테이너 데이터 변경
  function changeOGContainerDetailData(index, key, value) {
    let _container_detail_list_OG = [...container_detail_list_OG];
    _container_detail_list_OG[index][key] = value;
    setContainer_detail_list_OG(_container_detail_list_OG);
  }

  //컨테이너 정보 첨부파일 삭제
  function deleteAddMemoFile(index) {
    memo_files.splice(index, 1);
    setIsNeedUpdate(!isNeedUpdate);
  }

  //입력값 검사
  function checkValidation() {
    //회사정보
    if ($controller.sbf_COMP_NM.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.realShipper")
      );
      $controller.sbf_COMP_NM.current.focus();
      return false;
    }

    //부킹담당자
    if ($controller.sbf_USER_NAME.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.bookEmpName")
      );
      $controller.sbf_USER_NAME.current.focus();
      return false;
    }
    if ($controller.sbf_BOOK_TEL.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.bookEmpTel")
      );
      $controller.sbf_BOOK_TEL.current.focus();
      return false;
    }
    if ($controller.sbf_BOOK_MOBILE.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.bookEmpPhone")
      );
      $controller.sbf_BOOK_MOBILE.current.focus();
      return false;
    }
    if ($controller.sbf_USER_ID.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.bookEmpEmail")
      );
      $controller.sbf_USER_ID.current.focus();
      return false;
    }
    //서류담당자
    if ($controller.sbf_DOC_USER_NAME.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.docEmpName")
      );
      $controller.sbf_DOC_USER_NAME.current.focus();
      return false;
    }
    if ($controller.sbf_DOC_USER_TEL.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.docEmpTel")
      );
      $controller.sbf_DOC_USER_TEL.current.focus();
      return false;
    }
    if ($controller.sbf_DOC_USER_MOBILE.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.docEmpPhone")
      );
      $controller.sbf_DOC_USER_MOBILE.current.focus();
      return false;
    }
    if ($controller.sbf_DOC_USER_ID.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.docEmpEmail")
      );
      $controller.sbf_DOC_USER_ID.current.focus();
      return false;
    }
    //화물상세정보
    if ($controller.sbf_WEIGHT_CNT.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.freightWeight")
      );
      $controller.sbf_WEIGHT_CNT.current.focus();
      return false;
    }

    //운송조건
    if (
      $controller.sbf_TRAN_FREIGHT.current.value === "Collect" &&
      $controller.sbf_TRAN_FREIGHT_SCNO.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.scNo")
      );
      $controller.sbf_TRAN_FREIGHT_SCNO.current.focus();
      return false;
    }
    if ($controller.sbf_TRAN_TERM.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.term")
      );
      $controller.sbf_TRAN_TERM.current.focus();
      return false;
    }
    //운송요청 - 픽업정보
    if (
      $controller.sbf_PICK_DATE.current &&
      $controller.sbf_PICK_DATE.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.pickUpDate")
      );
      $controller.sbf_PICK_DATE.current.focus();
      return false;
    }
    if (
      $controller.sbf_PICK_PLACE.current &&
      $controller.sbf_PICK_PLACE.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.pickUpLocation")
      );
      $controller.sbf_PICK_PLACE.current.focus();
      return false;
    }

    if (
      $controller.sbf_PICK_USER_NM.current &&
      $controller.sbf_PICK_USER_NM.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.pickUpEmpName")
      );
      $controller.sbf_PICK_USER_NM.current.focus();
      return false;
    }

    if (
      $controller.sbf_PICK_USER_TEL.current &&
      $controller.sbf_PICK_USER_TEL.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.pickUpEmpTel")
      );
      $controller.sbf_PICK_USER_TEL.current.focus();
      return false;
    }

    //운송요청 - 도어정보
    if (
      $controller.sbf_FACT_DATE.current &&
      $controller.sbf_FACT_DATE.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.doorDate")
      );
      $controller.sbf_FACT_DATE.current.focus();
      return false;
    }
    if (
      $controller.sbf_FACT_PLACE.current &&
      $controller.sbf_FACT_PLACE.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.doorLocation")
      );
      $controller.sbf_FACT_PLACE.current.focus();
      return false;
    }

    if (
      $controller.sbf_FACT_USER_NM.current &&
      $controller.sbf_FACT_USER_NM.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.doorEmpName")
      );
      $controller.sbf_FACT_USER_NM.current.focus();
      return false;
    }

    if (
      $controller.sbf_FACT_USER_TEL.current &&
      $controller.sbf_FACT_USER_TEL.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.doorEmpTel")
      );
      $controller.sbf_FACT_USER_TEL.current.focus();
      return false;
    }

    //운송요청 - 입고정보
    if (
      $controller.sbf_CFS_DATE.current &&
      $controller.sbf_CFS_DATE.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.cfsDate")
      );
      $controller.sbf_CFS_DATE.current.focus();
      return false;
    }
    if (
      $controller.sbf_CFS_PLACE.current &&
      $controller.sbf_CFS_PLACE.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("schedule.fcl.reserveNamsung.msg.enter.cfsDate")
      );
      $controller.sbf_CFS_PLACE.current.focus();
      return false;
    }

    return true;
  }

  //컨테이너 데이터 입력 검사
  function checkValidationForContainer() {
    //기본컨테이너 및 Reefer컨테이너 리스트 검사
    let _container_detail_list = [...container_detail_list];
    for (let i = 0; i < _container_detail_list.length; i++) {
      let main_container = _container_detail_list[i];
      //  일반 컨테이너 입력검사
      if (main_container["sfc_TYPE"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.type")
        );
        return false;
      }
      if (main_container["sfc_SIZE"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.size")
        );
        return false;
      }
      if (
        main_container["sfc_CNT"].trim() === "" ||
        main_container["sfc_CNT"] === 0
      ) {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.cnt")
        );
        return false;
      }

      if (main_container["sfc_MAKER_YN"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.makerYN")
        );
        return false;
      }
      if (main_container["sfc_DANGER_YN"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.dangerYN")
        );
        return false;
      }
      if (main_container["sfc_EMPTY_YN"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.emptyYN")
        );
        return false;
      }

      if (main_container["sfc_FLEXI_YN"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.flexiYN")
        );
        return false;
      }

      if (main_container["sfc_TYPE"] === "RF") {
        //  냉동컨테이너 입력 검사
        if (main_container["sfc_TEMPERATURE"].trim() === "") {
          codeList.Modal.current.alert(
            t("schedule.fcl.reserveNamsung.msg.containerEnter.temp")
          );
          return false;
        }
        if (main_container["sfc_FAN_OPEN_PER"].trim() === "") {
          codeList.Modal.current.alert(
            t("schedule.fcl.reserveNamsung.msg.containerEnter.fan")
          );
          return false;
        }
      }
    }

    //OG 컨테이너 리스트 검사
    let _container_detail_list_OG = [...container_detail_list_OG];
    for (let i = 0; i < _container_detail_list_OG.length; i++) {
      let oog_container = _container_detail_list_OG[i];
      if (oog_container["sfc_LENGTH"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.ogLength")
        );
        return false;
      }
      if (oog_container["sfc_WIDTH"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.ogWidth")
        );
        return false;
      }
      if (oog_container["sfc_HEIGHT"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.ogHeight")
        );
        return false;
      }
      if (oog_container["sfc_VOID"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.ogVoid")
        );
        return false;
      }
      if (oog_container["sfc_WEIGHT"].trim() === "") {
        codeList.Modal.current.alert(
          t("schedule.fcl.reserveNamsung.msg.containerEnter.ogAddWeight")
        );
        return false;
      }
    }

    return true;
  }

  //임시저장
  function actionSave() {
    codeList.Modal.current.confirm(
      t("schedule.fcl.reserveNamsung.msg.confirm"),
      (ret) => {
        if (ret) {
          if (checkValidation() && checkValidationForContainer()) {
            let data = {
              sbf_IDX_MAIN: schedule_data.sm_IDX,
              sbf_UID_MAIN: schedule_data.sm_UID,

              sbf_BOOK_UID: sbf_BOOK_UID, //예약 UID
              sbf_COMP_CD: loginInfo.comp_cd, //업체코드
              sbf_COMP_NAME: loginInfo.comp_nm, //업체명

              sbf_SHIPPER: null, //SHIPPER
              sbf_COMP_NM: null, //실화주

              sbf_USER_NAME: null, //부킹담당자 이름
              sbf_BOOK_TEL: null, //부킹담당자 전화번호
              sbf_BOOK_MOBILE: null, //부킹담당자 휴대전화
              sbf_USER_ID: null, //부킹담당자 이메일
              sbf_BOOK_FAX: null, //부킹담당자 팩스

              sbf_DOC_USER_NAME: null, //서류담당자 이름
              sbf_DOC_USER_TEL: null, //서류담당자 전화번호
              sbf_DOC_USER_MOBILE: null, //서류담당자 휴대전화
              sbf_DOC_USER_ID: null, //서류담당자 이메일
              sbf_DOC_USER_FAX: null, //서류담당자 팩스

              sbf_WEIGHT_CNT: null, //화물 무게
              sbf_WEIGHT_TYPE: null, //화물 무게 구분

              sbf_TRAN_TYPE: null, // 운송조건 구분
              sbf_TRAN_FREIGHT: null, //운송조건 Freight
              sbf_TRAN_FREIGHT_SCNO: null, //운송조건 SC No.
              sbf_TRAN_TERM: null, //운송조건 SC No.

              sbf_PICK_DATE: null, //픽업날자
              sbf_PICK_TIME: null, //픽업 시간
              sbf_PICK_PLACE: null, //픽업위치
              sbf_PICK_USER_NM: null, //픽업 담당자 이름
              sbf_PICK_USER_TEL: null, //픽업 담당자 연락처
              sbf_PICK_MEMO: null, // 픽업 요청 메모

              sbf_FACT_DATE: null, //공장 작업일자
              sbf_FACT_TIME: null, //공장 작업 시간
              sbf_FACT_PLACE: null, //공장 작업장소
              sbf_FACT_USER_NM: null, //공장 담당자 이름
              sbf_FACT_USER_TEL: null, //공장 담당자 연락처
              sbf_FACT_MEMO: null, //공장 요청 메모

              sbf_CFS_DATE: null, //입고 날짜
              sbf_CFS_TIME: null, //입고 시간
              sbf_CFS_PLACE: null, // 입고 CFS
              sbf_CFS_MEMO: null, //입고 요청사항

              sbf_ETC_PRODUCT: null, //영문명
              sbf_ETC_RTN_YN: null, //반송화물 보세운송조건
              sbf_ETC_MEMO: null, //요청사항

              sbf_FILES: container_files.join("|"),
              sbf_ETC_FILES: memo_files.join("|"),

              sbf_CREATE_COMPCD: loginInfo.comp_cd,
              sbf_CREATE_USERID: loginInfo.user_id,
              sbf_UPDATE_COMPCD: loginInfo.comp_cd,
              sbf_UPDATE_USERID: loginInfo.user_id,
              containers: [
                ...container_detail_list,
                ...container_detail_list_OG,
              ],
              ...schedule_data,
            };
            for (let key in $controller) {
              if ($controller[key].current)
                data[key] = $controller[key].current.value || "";
            }
            INSERT_RESERVE_SCHEDULE_FCL(data);
          }
        }
      }
    );
  }

  //FCL 예약정보 서버통신
  function INSERT_RESERVE_SCHEDULE_FCL(data) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule_fcl_reserve/JS_schedule_fcl_reserve_insert.php",
      msgID: msgID,
      data: {},
      ...data,
    };
    setIsLoading(true);

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          codeList.Modal.current.alert(
            t("schedule.fcl.reserveNamsung.msg.success")
          );
          //초기화 및 이전 페이지로 넘기기 필요
          setContainer_detail_list_OG([]);
          setContainer_detail_list([]);
          navigate(-1);
        } else {
          codeList.Modal.current.alert(
            t("schedule.fcl.reserveNamsung.msg.fail")
          );
        }
        setIsLoading(false);
      }
    });
  }

  (() => {
    reefer_count = 0;
    oug_count = 0;
    for (let i = 0; i < container_detail_list.length; i++) {
      if (container_detail_list[i]["sfc_TYPE"] === "RF") {
        reefer_count++;
      }
      if (container_detail_list[i]["sfc_MAIN_TYPE"] === "O") {
        oug_count++;
      }
    }
  })();

  return (
    <>
      {isLoading && <Loading />}{" "}
      {isModalOpen && <NoteModal setIsModalOpen={setIsModalOpen} />}
      <CommonNav />
      <main style={{ marginTop: 60 }}>
        {isSuccessGetData && loginInfo && schedule_data && (
          <div className="container">
            <div className="row py-3 m-0 border-bottom">
              <div className="col-xl-12 m-0 p-0">
                <span className="h5 font-weight-bold mb-0">
                  {t("schedule.fcl.reserveNamsung.title")}
                </span>
              </div>
            </div>
            <div className="py-3 border-bottom">
              {/*요청자*/}
              <div className="row m-0 mb-3 p-0">
                <div className="col-12 m-0 p-0">
                  <span className="h6 mb-0">
                    ■ {t("schedule.fcl.reserveNamsung.booker")} :{" "}
                    <span className="font-weight-bold">
                      [{loginInfo.comp_nm}]{" "}
                      {loginInfo.USER_NICK || loginInfo.user_nm}
                    </span>
                  </span>
                </div>
              </div>

              {/*회사정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-lg-6 m-0 mb-2 p-0">
                  <div className="row m-0 mb-2 p-0">
                    <div className="col-lg-6 m-0 p-0">
                      <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                        {t("schedule.fcl.reserveNamsung.compInfo.title")}
                      </span>
                    </div>
                    <div className="col-lg-6 m-0 p-0 text-right">
                      <button
                        className="btn btn-sm btn-outline-secondary py-0 px-2 mr-2 font-size-06"
                        onClick={() => copyShipperComp()}
                      >
                        {t("schedule.fcl.reserveNamsung.compInfo.copyShipper")}
                      </button>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-lg-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          SHIPPER
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          readOnly={true}
                          ref={$controller.sbf_SHIPPER}
                          defaultValue={loginInfo.comp_nm}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 180 }}
                        >
                          {t(
                            "schedule.fcl.reserveNamsung.compInfo.realShipper"
                          )}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_COMP_NM}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*담당자 정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-12 m-0 mb-2 p-0">
                  <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                    {t("schedule.fcl.reserveNamsung.employeeInfo.title")}
                  </span>
                </div>
                <div className="col-lg-6 m-0 p-0">
                  <div className="row m-0 p-0">
                    <div className="col-xl-12 m-0 mb-2 p-0">
                      <span className="h6 mb-0 font-weight-bold">
                        {t("schedule.fcl.reserveNamsung.employeeInfo.bookEmp")}
                      </span>
                    </div>
                    <div className="col-xl-6 m-0 mb-xl-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.name")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_USER_NAME}
                          defaultValue={loginInfo.user_nm}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0" />
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.tel")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_BOOK_TEL}
                          defaultValue={loginInfo.COMP_TEL}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.phone")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_BOOK_MOBILE}
                          defaultValue={loginInfo.user_tel}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.email")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_USER_ID}
                          defaultValue={loginInfo.user_id}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          FAX
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_BOOK_FAX}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 m-0 p-0">
                  <div className="row m-0 p-0">
                    <div className="col-xl-6 m-0 mb-xl-2 p-0 d-flex flex-row justify-content-between align-items-center">
                      <span className="h6 mb-0 font-weight-bold">
                        {t("schedule.fcl.reserveNamsung.employeeInfo.docEmp")}
                      </span>
                      <button
                        className="btn btn-sm px-2 py-0 btn-outline-secondary font-size-06 mr-2"
                        onClick={() => copyEmployeeInfo()}
                      >
                        {t(
                          "schedule.fcl.reserveNamsung.employeeInfo.copyBookEmp"
                        )}
                      </button>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0" />
                    <div className="col-xl-6 m-0 mb-xl-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.name")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_DOC_USER_NAME}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0" />
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.tel")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_DOC_USER_TEL}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.phone")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_DOC_USER_MOBILE}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          {t("schedule.fcl.reserveNamsung.employeeInfo.email")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_DOC_USER_ID}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          FAX
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_DOC_USER_FAX}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*요청 스케쥴정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-xl-12 m-0 mb-2 p-0">
                  <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                    {t("schedule.fcl.reserveNamsung.bookSchedule.title")}
                  </span>
                </div>
                <div className="col-xl-12 m-0 p-0 mb-2">
                  <div className="row m-0 p-0">
                    <div className="col-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.bookSchedule.scheduleNo"
                        )}
                      </div>
                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_UID}
                      </div>
                    </div>
                    <div className="col-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t("schedule.fcl.reserveNamsung.bookSchedule.carrier")}
                      </div>
                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {!schedule_data.COMP_LOGO && schedule_data.sm_FWD_NM}
                        {schedule_data.COMP_LOGO && (
                          <div
                            className="w-100 h-100"
                            style={{
                              minWidth: 80,
                              background: `url(${
                                schedule_data.COMP_LOGO.split("?")[0]
                              }) 50% 50% / contain no-repeat`,
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        FCL/LCL
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_FCL_LCL}
                      </div>
                    </div>
                    <div className="col-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        VESSEL/VOY
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        <p>{schedule_data.sm_VESSEL}</p>
                        <p>{schedule_data.sm_VOY}</p>
                      </div>
                    </div>
                    <div className="col-6 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        POL
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        <p className="font-weight-bold">
                          {schedule_data.sm_ORIGIN}
                        </p>
                        <p className="font-weight-bold text-danger">
                          {schedule_data.sm_DEPARTURE_DATE} (
                          {util.handleGetDate(schedule_data.sm_DEPARTURE_DATE)})
                        </p>
                      </div>
                    </div>
                    <div className="col-6 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        POD
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        <p className="font-weight-bold">
                          {schedule_data.sm_DEST}
                        </p>
                        <p className="font-weight-bold text-danger">
                          {schedule_data.sm_ARRIVE_DATE} (
                          {util.handleGetDate(schedule_data.sm_ARRIVE_DATE)})
                        </p>
                      </div>
                    </div>
                    <div className="col-6 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-secondary text-white font-weight-bold p-2">
                        T/S Port
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_TS_PORT || "-"}
                      </div>
                    </div>
                    <div className="col-6 col-xl-auto flex-grow-1 text-center m-0 p-0 d-flex flex-column">
                      <div className="bg-secondary text-white font-weight-bold p-2">
                        2<sup>nd</sup> Vessel
                      </div>
                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_2ND_VESSEL || "-"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 m-0 p-0 mb-2">
                  <p className="text-secondary">
                    ※ {t("schedule.fcl.reserveNamsung.bookSchedule.notice")}
                  </p>
                </div>
              </div>

              {/*업무 스케쥴 정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-xl-12 m-0 mb-2 p-0">
                  <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                    {t("schedule.fcl.reserveNamsung.workScheduleInfo.title")}
                  </span>
                </div>
                <div className="col-xl-12 m-0 p-0 mb-2">
                  <div className="row m-0 p-0">
                    <div className="col-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.workScheduleInfo.docClose"
                        )}
                      </div>
                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_DOC_CLOSE}{" "}
                        {schedule_data.sm_DOC_CLOSE_TIME}
                      </div>
                    </div>
                    <div className="col-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.workScheduleInfo.ediClose"
                        )}
                      </div>
                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_EDI_DATE || "-"}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.workScheduleInfo.cfsClose"
                        )}
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_CFS_DATE || "-"} {" / "}
                        {schedule_data.sm_AFR_DATE || "-"}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.workScheduleInfo.containerClose"
                        )}
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        {schedule_data.sm_CARGO_CLOSE}{" "}
                        {schedule_data.sm_CARGO_CLOSE_TIME}
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1 d-flex flex-row flex-xl-row flex-wrap ">
                    <div className="col-6 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.workScheduleInfo.departureTerminal"
                        )}
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        <p>{schedule_data.sm_ARRIVE_TERMINAL || "-"}</p>
                      </div>
                    </div>
                    <div className="col-6 col-xl-auto flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.workScheduleInfo.arrivalTerminal"
                        )}
                      </div>

                      <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
                        <p>{schedule_data.sm_DEPARTURE_TERMINAL || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 m-0 p-0 mb-2">
                  <span className="text-secondary mr-2">
                    ※ {t("schedule.fcl.reserveNamsung.workScheduleInfo.notice")}
                  </span>
                  <button
                    className="btn btn-sm btn-info py-1 px-2 mr-2 font-size-04"
                    onClick={() => requestEnquiry(0)}
                  >
                    {t(
                      "schedule.fcl.reserveNamsung.workScheduleInfo.linkSalesEmp"
                    )}
                    <i className="fa-solid fa-headset ml-2" />
                  </button>
                  <button
                    className="btn btn-sm btn-secondary py-1 px-2 mr-2 font-size-04"
                    onClick={() => requestEnquiry(1)}
                  >
                    {t(
                      "schedule.fcl.reserveNamsung.workScheduleInfo.linkWorkEmp"
                    )}
                    <i className="fa-solid fa-file-lines ml-2" />
                  </button>
                </div>
              </div>

              {/*화물 상세정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-xl-6 m-0 mb-2 p-0">
                  <div className="row m-0 mb-2 p-0">
                    <div className="col-xl-12 m-0 p-0">
                      <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                        {t("schedule.fcl.reserveNamsung.freightDetail")}
                      </span>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-12 col-lg-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 150 }}
                        >
                          Gross Weight
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="number"
                          ref={$controller.sbf_WEIGHT_CNT}
                          style={{ width: 150 }}
                        />
                      </div>
                    </div>
                    <div className="col-6 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start align-items-center overflow-hidden h-100 mr-2">
                        <input
                          className={"d-none"}
                          ref={$controller.sbf_WEIGHT_TYPE}
                          defaultValue="KG"
                        />
                        <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                          <input
                            type="radio"
                            className="mr-1"
                            defaultChecked={true}
                            name="sbf_WEIGHT_CNT"
                            onClick={(e) => {
                              $controller.sbf_WEIGHT_TYPE.current.value = "KG";
                            }}
                          />{" "}
                          KG
                        </label>
                        <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                          <input
                            type="radio"
                            className="mr-1"
                            name="sbf_WEIGHT_CNT"
                            onClick={(e) => {
                              $controller.sbf_WEIGHT_TYPE.current.value = "TON";
                            }}
                          />{" "}
                          TON
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*컨테이너 정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-12 col-md-6 m-0 mb-2 p-0">
                  <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                    {t("schedule.fcl.reserveNamsung.containerInfo.title")}
                  </span>
                  <span className="d-block d-lg-inline-block font-weight-bold text-danger ml-lg-2">
                    {t("schedule.fcl.reserveNamsung.containerInfo.notice")}
                  </span>
                </div>
                <div className="col-12 col-md-6 m-0 mb-2 p-0 text-right">
                  <button
                    className="btn btn-sm btn-light py-1 px-2 font-size-09"
                    onClick={() => addContainerInfo("M")}
                  >
                    {t(
                      "schedule.fcl.reserveNamsung.containerInfo.addContainer"
                    )}{" "}
                    +
                  </button>
                </div>
                <div className="col-12 m-0 p-0 mb-2 overflow_scroll">
                  <div
                    className="row flex-nowrap m-0 p-0"
                    style={{ width: 1110 }}
                  >
                    <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        Type
                      </div>
                    </div>
                    <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        Size
                      </div>
                    </div>

                    <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        Q'ty
                      </div>
                    </div>
                    <div className="col-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.containerInfo.shipperContainer"
                        )}
                      </div>
                    </div>
                    <div className="col-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.containerInfo.dangerousContainer"
                        )}
                      </div>
                    </div>
                    <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        Empyt
                      </div>
                    </div>
                    <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        Flexi-Bag
                      </div>
                    </div>
                    <div className="col-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                      <div className="bg-info text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.containerInfo.requestMemo"
                        )}
                      </div>
                    </div>
                    <div className="col-1 flex-grow-1 text-center m-0 p-0 d-flex flex-column">
                      <div className="bg-secondary text-white font-weight-bold p-2">
                        {t(
                          "schedule.fcl.reserveNamsung.containerInfo.deleteContainer"
                        )}
                      </div>
                    </div>
                  </div>

                  {container_detail_list.map((item, index) => {
                    return (
                      <ContainerInfoRow
                        item={item}
                        index={index}
                        setIsModalOpen={setIsModalOpen}
                        deleteContainerInfo={deleteContainerInfo}
                        changeContainerDetailData={changeContainerDetailData}
                        key={item.id}
                      />
                    );
                  })}
                </div>
                <div className="col-xl-12 m-0 p-0 mb-2">
                  <div className="row m-0 p-0">
                    <span className="d-flex flex-row justify-content-center align-items-center bg-info text-white rounded px-5 mr-2">
                      {t("schedule.fcl.reserveNamsung.containerInfo.addFile")}
                    </span>
                    <UploadImageToS3WithPhp
                      region={`mall/reserveFcl/${schedule_data.sm_UID}`}
                      callback={(val) => {
                        uploadContainerFile(val);
                      }}
                    >
                      <span className="d-flex flex-row align-items-center btn btn-sm btn-secondary h-100 px-3">
                        +
                      </span>
                    </UploadImageToS3WithPhp>
                  </div>
                </div>
                <div>
                  {container_files.length > 0 &&
                    container_files.map((item, index) => {
                      let split_data = item.split("?");
                      let file_name = split_data[0];
                      let file_link = split_data[1];
                      return (
                        <div
                          key={item + "_" + index}
                          className="d-flex flex-row align-items-center mb-1"
                        >
                          <span
                            className="cursor_pointer text-underline text-primary mr-2"
                            onClick={() => {
                              window.open(
                                file_link,
                                "_blank",
                                "width=1200, height=800"
                              );
                            }}
                          >
                            {file_name}
                          </span>
                          <button
                            className="btn btn-sm btn-danger px-2 py-1  font-size-06"
                            onClick={() => deleteContainerFile(index)}
                          >
                            {t(
                              "schedule.fcl.reserveNamsung.containerInfo.deleteContainer"
                            )}
                          </button>
                        </div>
                      );
                    })}
                </div>
              </div>

              {(reefer_count > 0 || container_detail_list_OG.length > 0) && (
                <div className="row m-0 mb-4 p-0">
                  <div className="col-xl-12 m-0 mb-2 p-0">
                    <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                      {t(
                        "schedule.fcl.reserveNamsung.containerAddedInfo.title"
                      )}
                    </span>
                  </div>
                  {reefer_count > 0 && (
                    <div className="col-xl-12 m-0 p-0 mb-3">
                      <div className="col-xl-12 m-0 mb-2 p-0">
                        <span className="h6 mb-0 font-weight-bold">
                          {t(
                            "schedule.fcl.reserveNamsung.containerAddedInfo.reeferInfo"
                          )}
                        </span>
                      </div>
                      <div className="col-12 m-0 p-0 mb-2 overflow_scroll">
                        <div
                          className="row flex-nowrap m-0 p-0"
                          style={{ width: 1110 }}
                        >
                          <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-freiscop text-white font-weight-bold p-2">
                              Type
                            </div>
                          </div>
                          <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-freiscop text-white font-weight-bold p-2">
                              Size
                            </div>
                          </div>
                          <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              {t(
                                "schedule.fcl.reserveNamsung.containerAddedInfo.temp"
                              )}
                            </div>
                          </div>
                          <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              {t(
                                "schedule.fcl.reserveNamsung.containerAddedInfo.fanOpen"
                              )}
                            </div>
                          </div>
                        </div>
                        {container_detail_list.map((item, index) => {
                          if (item.sfc_TYPE === "RF") {
                            return (
                              <ReeferContainerInfoRow
                                key={item.id}
                                item={item}
                                index={index}
                                deleteContainerInfo={deleteContainerInfo}
                                changeContainerDetailData={
                                  changeContainerDetailData
                                }
                              />
                            );
                          }
                        })}
                      </div>
                    </div>
                  )}
                  {container_detail_list_OG.length > 0 && (
                    <div className="col-xl-12 m-0 p-0 mb-3">
                      <div className="col-xl-12 m-0 mb-2 p-0">
                        <span className="h6 mb-0 font-weight-bold mr-2">
                          {t(
                            "schedule.fcl.reserveNamsung.containerAddedInfo.ogInfo"
                          )}
                        </span>
                        <button className="btn btn-sm btn-outline-secondary px-2 py-1 font-size-08 mt-1 mt-lg-0">
                          {t(
                            "schedule.fcl.reserveNamsung.containerAddedInfo.containerSize"
                          )}
                        </button>
                      </div>

                      <div className="col-12 m-0 p-0 mb-2 overflow_scroll">
                        <div
                          className="row flex-nowrap m-0 p-0 font-size-09"
                          style={{ width: 1110 }}
                        >
                          <div className="col-xl-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-freiscop text-white font-weight-bold p-2">
                              Type
                            </div>
                          </div>
                          <div className="col-xl-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-freiscop text-white font-weight-bold p-2">
                              Size
                            </div>
                          </div>
                          <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              Length(mm)
                            </div>
                          </div>
                          <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              Width(mm)
                            </div>
                          </div>
                          <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              Height(mm)
                            </div>
                          </div>
                          <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              Void(teu)
                            </div>
                          </div>
                          <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              Weight(kg)
                            </div>
                          </div>
                          <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
                            <div className="bg-info text-white font-weight-bold p-2">
                              {t(
                                "schedule.fcl.reserveNamsung.containerAddedInfo.request"
                              )}
                            </div>
                          </div>
                        </div>

                        {container_detail_list_OG.map((item, index) => {
                          return (
                            <OUGContainerInfoRow
                              key={item.id}
                              item={item}
                              index={index}
                              deleteContainerInfo={deleteContainerInfo}
                              changeContainerDetailData={
                                changeOGContainerDetailData
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/*운송조건*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-xl-12 m-0 mb-2 p-0">
                  <div className="row m-0 mb-2 p-0">
                    <div className="col-xl-12 m-0 p-0">
                      <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                        {t(
                          "schedule.fcl.reserveNamsung.shippingConditions.title"
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-xl-12 m-0 p-0 d-flex flex-row flex-wrap justify-content-start align-items-center">
                      <div className="mb-2 d-flex flex-row justify-content-start align-items-center">
                        <div className="bg-info text-white py-1 px-2 font-weight-bold rounded px-3">
                          {t(
                            "schedule.fcl.reserveNamsung.shippingConditions.division"
                          )}
                        </div>
                        <div className="d-flex flex-row justify-content-start align-items-center overflow-hidden h-100 mx-2">
                          <input
                            type="text"
                            className="d-none"
                            ref={$controller.sbf_TRAN_TYPE}
                            defaultValue="LINE"
                          />
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                            <input
                              type="radio"
                              className="mr-1"
                              defaultChecked={true}
                              name="sbf_TRAN_TYPE"
                              onClick={() => {
                                $controller.sbf_TRAN_TYPE.current.value =
                                  "LINE";
                                setTransitType("LINE");
                              }}
                            />{" "}
                            {t(
                              "schedule.fcl.reserveNamsung.shippingConditions.lineTransportation"
                            )}
                          </label>
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                            <input
                              type="radio"
                              className="mr-1"
                              name="sbf_TRAN_TYPE"
                              onClick={() => {
                                $controller.sbf_TRAN_TYPE.current.value =
                                  "SELF";
                                setTransitType("SELF");
                              }}
                            />{" "}
                            {t(
                              "schedule.fcl.reserveNamsung.shippingConditions.selfTransportation"
                            )}
                          </label>
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                            <input
                              type="radio"
                              className="mr-1"
                              name="sbf_TRAN_TYPE"
                              onClick={() => {
                                $controller.sbf_TRAN_TYPE.current.value = "CFS";
                                setTransitType("CFS");
                              }}
                            />{" "}
                            CFS
                          </label>
                        </div>
                      </div>
                      <div className="mb-2 d-flex flex-row align-items-start align-items-sm-center">
                        <div className="bg-info text-white py-1 px-2 font-weight-bold rounded px-3">
                          Freight
                        </div>
                        <div className="d-flex flex-row flex-wrap justify-content-start align-items-center overflow-hidden h-100 mx-2">
                          <input
                            type="text"
                            className="d-none"
                            ref={$controller.sbf_TRAN_FREIGHT}
                            defaultValue="Prepaid"
                          />
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center mb-1 mb-sm-0">
                            <input
                              type="radio"
                              className="mr-1"
                              defaultChecked={true}
                              name="sbf_TRAN_FREIGHT"
                              onClick={() => {
                                $controller.sbf_TRAN_FREIGHT.current.value =
                                  "Prepaid";
                                $controller.sbf_TRAN_FREIGHT_SCNO.current.value =
                                  "";
                                $controller.sbf_TRAN_FREIGHT_SCNO.current.disabled = true;
                              }}
                            />{" "}
                            Prepaid
                          </label>
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center mb-1 mb-sm-0">
                            <input
                              type="radio"
                              className="mr-1"
                              name="sbf_TRAN_FREIGHT"
                              onClick={() => {
                                $controller.sbf_TRAN_FREIGHT.current.value =
                                  "Collect";
                                $controller.sbf_TRAN_FREIGHT_SCNO.current.disabled = false;
                              }}
                            />{" "}
                            Collect
                          </label>
                          <input
                            type="text"
                            className="border rounded"
                            disabled={true}
                            ref={$controller.sbf_TRAN_FREIGHT_SCNO}
                            placeholder={t(
                              "schedule.fcl.reserveNamsung.shippingConditions.scNoPlaceholder"
                            )}
                          />
                        </div>
                      </div>
                      <div className="mb-2 d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 100 }}
                        >
                          Term
                        </div>

                        <select
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          style={{ width: 200 }}
                          disabled={sbf_TRAN_TYPE !== "SELF"}
                          ref={$controller.sbf_TRAN_TERM}
                        >
                          {sbf_TRAN_TYPE === "LINE" && (
                            <option value="CY-CY">CY-CY</option>
                          )}
                          {sbf_TRAN_TYPE === "SELF" && (
                            <>
                              <option value="">
                                {t(
                                  "schedule.fcl.reserveNamsung.shippingConditions.unSelect"
                                )}
                              </option>
                              <option value="CY-CY">CY-CY</option>
                              <option value="CFS-CY">CFS-CY</option>
                            </>
                          )}
                          {sbf_TRAN_TYPE === "CFS" && (
                            <option value="CFS-CY">CFS-CY</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*운송 요청*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-xl-12 m-0 mb-2 p-0">
                  <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                    {t(
                      "schedule.fcl.reserveNamsung.requestTransportation.title"
                    )}
                  </span>
                </div>

                <div className="col-xl-12 m-0 p-0">
                  {sbf_TRAN_TYPE === "LINE" && (
                    <div className="row m-0 p-0">
                      <div className="col-xl-6 m-0 p-0">
                        <div className="row m-0 p-0">
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <span className="h6 mb-0 font-weight-bold">
                              {t(
                                "schedule.fcl.reserveNamsung.requestTransportation.pickUpInfo"
                              )}
                            </span>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 rounded overflow-hidden mr-2">
                              <div className="col-4 bg-info text-white py-1 px-2 text-center font-weight-bold rounded-top-left rounded-bottom-left">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpDate"
                                )}
                              </div>
                              <input
                                className="col-5 form-control p-0 px-2 rounded-0 m-0 h-unset font-size-08"
                                type="date"
                                ref={$controller.sbf_PICK_DATE}
                              />
                              <select
                                className="col-3 form-control rounded-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset font-size-08 border-left-0"
                                ref={$controller.sbf_PICK_TIME}
                              >
                                {times.map((time) => {
                                  return (
                                    <option key={time} value={time}>
                                      {time}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 rounded overflow-hidden mr-2">
                              <div className="col-4 bg-info rounded-top-left rounded-bottom-left text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpLocation"
                                )}
                              </div>
                              <select
                                className="col-8 form-control rounded-0  rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset font-size-08"
                                ref={$controller.sbf_PICK_PLACE}
                              >
                                <option value="">
                                  {t(
                                    "schedule.fcl.reserveNamsung.requestTransportation.unselect"
                                  )}
                                </option>
                                {pickPlace.map((item) => {
                                  return (
                                    <option key={item.ppCode}>
                                      {item.ppRemark}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 bg-info rounded-top-left rounded-bottom-left text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.employee"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_PICK_USER_NM}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.tel"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_PICK_USER_TEL}
                              />
                            </div>
                          </div>
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 col-xl-2 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpRequestMemo"
                                )}
                              </div>
                              <input
                                className="col-8 col-xl-10 form-control rounded-0 rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_PICK_MEMO}
                                placeholder={t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpRequestMemoPlaceholder"
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 m-0 p-0">
                        <div className="row m-0 p-0">
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <span className="h6 mb-0 font-weight-bold">
                              {t(
                                "schedule.fcl.reserveNamsung.requestTransportation.doorInfo"
                              )}
                            </span>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.workDate"
                                )}
                              </div>
                              <input
                                className="col-5 form-control rounded-0 p-0 px-2 m-0 h-unset font-size-08"
                                type="date"
                                ref={$controller.sbf_FACT_DATE}
                              />
                              <select
                                className="col-3 form-control border-left-0 rounded-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset font-size-08"
                                ref={$controller.sbf_FACT_TIME}
                              >
                                {times.map((time) => {
                                  return (
                                    <option key={time} value={time}>
                                      {time}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.workLocation"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-0 rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_FACT_PLACE}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info  text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.employee"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-0 rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_FACT_USER_NM}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.tel"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                style={{ width: 200 }}
                                ref={$controller.sbf_FACT_USER_TEL}
                              />
                            </div>
                          </div>
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div
                                className="col-4 col-xl-2  rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold"
                                style={{ width: 100 }}
                              >
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.doorRequestMemo"
                                )}
                              </div>
                              <input
                                className="col-8 col-xl-10 form-control rounded-0 rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_FACT_MEMO}
                                placeholder={t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.doorRequestMemoPlaceholder"
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {sbf_TRAN_TYPE === "SELF" && (
                    <div className="row m-0 p-0">
                      <div className="col-xl-6 m-0 p-0">
                        <div className="row m-0 p-0">
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <span className="h6 mb-0 font-weight-bold">
                              {t(
                                "schedule.fcl.reserveNamsung.requestTransportation.pickUpInfo"
                              )}
                            </span>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpDate"
                                )}
                              </div>
                              <input
                                className="col-5 form-control rounded-0 p-0 px-2 m-0 h-unset font-size-08"
                                type="date"
                                ref={$controller.sbf_PICK_DATE}
                              />
                              <select
                                className="col-3 form-control rounded-0 border-left-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset font-size-08"
                                ref={$controller.sbf_PICK_TIME}
                              >
                                {times.map((time) => {
                                  return (
                                    <option key={time} value={time}>
                                      {time}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpLocation"
                                )}
                              </div>
                              <select
                                className="col-8 form-control rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset font-size-08"
                                style={{ width: 200 }}
                                ref={$controller.sbf_PICK_PLACE}
                              >
                                <option value="">
                                  {t(
                                    "schedule.fcl.reserveNamsung.requestTransportation.unselect"
                                  )}
                                </option>
                                {pickPlace.map((item) => {
                                  return (
                                    <option key={item.ppCode}>
                                      {item.ppRemark}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.employee"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_PICK_USER_NM}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.tel"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_PICK_USER_TEL}
                              />
                            </div>
                          </div>
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 col-xl-2 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpRequestMemo"
                                )}
                              </div>
                              <input
                                className="col-8 col-xl-10 form-control rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_PICK_MEMO}
                                placeholder={t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.pickUpRequestMemoPlaceholder"
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {sbf_TRAN_TYPE === "CFS" && (
                    <div className="row m-0 p-0">
                      <div className="col-xl-6 m-0 p-0">
                        <div className="row m-0 p-0">
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <span className="h6 mb-0 font-weight-bold">
                              {t(
                                "schedule.fcl.reserveNamsung.requestTransportation.cfsInfo"
                              )}
                            </span>
                          </div>
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.cfsDate"
                                )}
                              </div>
                              <input
                                className="col-5 form-control rounded-0 p-0 px-2 m-0 h-unset font-size-08"
                                type="date"
                                ref={$controller.sbf_CFS_DATE}
                              />
                              <select
                                className="col-3 form-control border-left-0 rounded-0 rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset font-size-08"
                                ref={$controller.sbf_CFS_TIME}
                              >
                                {times.map((time) => {
                                  return (
                                    <option key={time} value={time}>
                                      {time}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                CFS
                              </div>

                              <input
                                className="col-8 form-control rounded-top-right rounded-bottom-right p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_CFS_PLACE}
                                placeholder={t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.cfsPlaceholder"
                                )}
                                defaultValue={cfs_data.CFS_TEL_L || ""}
                                readOnly={!!cfs_data.CFS_TEL_L}
                              />
                            </div>
                          </div>
                          <div className="col-xl-12 m-0 mb-2 p-0">
                            <div className="row m-0 p-0 mr-2">
                              <div className="col-4 rounded-top-left rounded-bottom-left bg-info text-white py-1 px-2 text-center font-weight-bold">
                                {t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.cfsRequestMemo"
                                )}
                              </div>
                              <input
                                className="col-8 form-control rounded-top-right rounded-bottom-right  p-0 px-2 m-0 h-unset flex-fill"
                                type="text"
                                ref={$controller.sbf_CFS_MEMO}
                                placeholder={t(
                                  "schedule.fcl.reserveNamsung.requestTransportation.cfsRequestPlaceholder"
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/*추가정보*/}
              <div className="row m-0 mb-4 p-0">
                <div className="col-xl-6 m-0 mb-2 p-0">
                  <div className="row m-0 mb-2 p-0">
                    <div className="col-xl-12 m-0 p-0">
                      <span className="h6 mb-0 d-inline-block py-1 px-2 font-weight-bold bg-secondary text-white">
                        {t("schedule.fcl.reserveNamsung.etcInfo.title")}
                      </span>
                    </div>
                  </div>
                  <div className="row m-0 p-0">
                    <div className="col-xl-12 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 200 }}
                        >
                          {t("schedule.fcl.reserveNamsung.etcInfo.productName")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          ref={$controller.sbf_ETC_PRODUCT}
                          style={{ width: 200 }}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start  overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold rounded"
                          style={{ width: 200 }}
                        >
                          {t(
                            "schedule.fcl.reserveNamsung.etcInfo.boundedCondition"
                          )}
                        </div>
                        <div className="d-flex flex-row justify-content-start px-2">
                          <input
                            type="text"
                            ref={$controller.sbf_ETC_RTN_YN}
                            defaultValue="N"
                            className="d-none"
                          />
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                            <input
                              type="radio"
                              className="mr-1"
                              defaultChecked={true}
                              name="sbf_ETC_RTN_YN"
                              onClick={() => {
                                $controller.sbf_ETC_RTN_YN.current.value = "N";
                              }}
                            />{" "}
                            No
                          </label>
                          <label className="m-0 p-0 font-weight-bold mr-2 d-flex flex-row align-items-center">
                            <input
                              type="radio"
                              className="mr-1"
                              name="sbf_ETC_RTN_YN"
                              onClick={() => {
                                $controller.sbf_ETC_RTN_YN.current.value = "Y";
                              }}
                            />{" "}
                            Yes
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12 m-0 mb-2 p-0">
                      <div className="d-flex flex-row justify-content-start rounded overflow-hidden mr-2">
                        <div
                          className="bg-info text-white py-1 px-2 text-center font-weight-bold"
                          style={{ width: 200 }}
                        >
                          {t("schedule.fcl.reserveNamsung.etcInfo.requestMemo")}
                        </div>
                        <input
                          className="form-control p-0 px-2 m-0 h-unset flex-fill"
                          type="text"
                          style={{ width: 200 }}
                          ref={$controller.sbf_ETC_MEMO}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 m-0 p-0 mb-3">
                      <div className=" d-flex flex-row align-items-center">
                        <span
                          className="bg-info text-white text-center rounded px-5 py-1 mr-2"
                          style={{ width: 200 }}
                        >
                          {t("schedule.fcl.reserveNamsung.etcInfo.addFile")}
                        </span>
                        <UploadImageToS3WithPhp
                          region={`mall/reserveFcl/${schedule_data.sm_UID}`}
                          callback={(val) => {
                            uploadAddMemoFile(val);
                          }}
                        >
                          <span className="btn btn-sm btn-secondary py-0 mt-1">
                            +
                          </span>
                        </UploadImageToS3WithPhp>
                      </div>
                      <div>
                        {memo_files.length > 0 &&
                          memo_files.map((item, index) => {
                            let split_data = item.split("?");
                            let file_name = split_data[0];
                            let file_link = split_data[1];
                            return (
                              <div
                                key={item + "_" + index}
                                className="d-flex flex-row align-items-center mb-1"
                              >
                                <span
                                  className="cursor_pointer text-underline text-primary mr-2"
                                  onClick={() => {
                                    window.open(
                                      file_link,
                                      "_blank",
                                      "width=1200, height=800"
                                    );
                                  }}
                                >
                                  {file_name}
                                </span>
                                <button
                                  className="btn btn-sm btn-danger px-2 py-1  font-size-06"
                                  onClick={() => deleteAddMemoFile(index)}
                                >
                                  {t(
                                    "schedule.fcl.reserveNamsung.etcInfo.delete"
                                  )}
                                </button>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button
                  className="btn btn-sm btn-outline-info text-freiscop border-freiscop mr-2"
                  onClick={() => {
                    actionSave();
                  }}
                >
                  {t("schedule.fcl.reserveNamsung.submit")}
                  <i className="fa-solid fa-arrow-up-from-bracket ml-1" />
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}

//컨테이너 기본 정보
const ContainerInfoRow = React.memo((props) => {
  const {
    item,
    index,
    setIsModalOpen,
    deleteContainerInfo,
    changeContainerDetailData,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="row flex-nowrap m-0 p-0" style={{ width: 1110 }}>
      <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_TYPE}
            onChange={(e) => {
              changeContainerDetailData(index, "sfc_TYPE", e.target.value);
            }}
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="DC">Dry</option>
            <option value="RF">Reefer</option>
            <option value="TC">Tank</option>
            <option value="OT">Open Top</option>
            <option value="FR">Flat Rack</option>
          </select>
        </div>
      </div>
      <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_SIZE}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_SIZE", e.target.value)
            }
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="20">20`</option>
            <option value="40">40`</option>
            <option value="4H">40`HQ</option>
            <option value="45">45`</option>
          </select>
        </div>
      </div>

      <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="number"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t(
              "schedule.fcl.reserveNamsung.containerInfo.enterQuantity"
            )}
            min={1}
            value={item.sfc_CNT}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_CNT", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_MAKER_YN}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_MAKER_YN", e.target.value)
            }
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>
        </div>
      </div>
      <div className="col-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_DANGER_YN}
            onChange={(e) => {
              if (e.target.value === "Y" && dgNoteActive === 0) {
                note_modal_data = {
                  title: t(
                    "schedule.fcl.reserveNamsung.containerInfo.msgDGDocTitle"
                  ),
                  desc: t(
                    "schedule.fcl.reserveNamsung.containerInfo.msgDGDocDesc"
                  ),
                };
                dgNoteActive = 1;
                setIsModalOpen(true);
              }
              changeContainerDetailData(index, "sfc_DANGER_YN", e.target.value);
            }}
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>
        </div>
      </div>
      <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_EMPTY_YN}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_EMPTY_YN", e.target.value)
            }
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>
        </div>
      </div>
      <div className="col-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_FLEXI_YN}
            onChange={(e) => {
              if (e.target.value === "Y" && flexiBagActive === 0) {
                note_modal_data = {
                  title: t(
                    "schedule.fcl.reserveNamsung.containerInfo.msgFlexiTitle"
                  ),
                  desc: t(
                    "schedule.fcl.reserveNamsung.containerInfo.msgFlexiDesc"
                  ),
                };
                flexiBagActive = 1;
                setIsModalOpen(true);
              }
              changeContainerDetailData(index, "sfc_FLEXI_YN", e.target.value);
            }}
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>
        </div>
      </div>
      <div className="col-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="text"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t(
              "schedule.fcl.reserveNamsung.containerInfo.requestMemoPlaceholder"
            )}
            value={item.sfc_MEMO}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_MEMO", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-1 flex-grow-1 text-center m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <button
            className="btn btn-sm text-danger"
            onClick={() => deleteContainerInfo(index)}
          >
            <i className="fa-solid fa-minus" />
          </button>
        </div>
      </div>
    </div>
  );
});

//냉동 컨테이너 정보
const ReeferContainerInfoRow = React.memo((props) => {
  const { item, index, changeContainerDetailData } = props;
  const { t } = useTranslation();
  return (
    <div className="row flex-nowrap m-0 p-0" style={{ width: 1110 }}>
      <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <span className="text-center border-0 ">Reefer</span>
        </div>
      </div>
      <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <span className="text-center border-0 ">
            {sfc_SIZE[item.sfc_SIZE]}
          </span>
        </div>
      </div>
      <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="number"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t(
              "schedule.fcl.reserveNamsung.containerInfo.enterTemper"
            )}
            onChange={(e) =>
              changeContainerDetailData(
                index,
                "sfc_TEMPERATURE",
                e.target.value
              )
            }
          />
        </div>
      </div>
      <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            onChange={(e) =>
              changeContainerDetailData(
                index,
                "sfc_FAN_OPEN_PER",
                e.target.value
              )
            }
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unSelect")}
            </option>
            <option value="0">CLOSE</option>
            <option value="100">FULL OPEN</option>
            <option value="10">10% OPEN</option>
            <option value="20">20% OPEN</option>
            <option value="30">30% OPEN</option>
            <option value="40">40% OPEN</option>
            <option value="50">50% OPEN</option>
            <option value="60">60% OPEN</option>
            <option value="70">70% OPEN</option>
            <option value="80">80% OPEN</option>
            <option value="90">90% OPEN</option>
          </select>
        </div>
      </div>
    </div>
  );
});

//OUG 컨테이너 정보
const OUGContainerInfoRow = React.memo((props) => {
  const { item, index, changeContainerDetailData } = props;
  const { t } = useTranslation();
  return (
    <div
      className="row flex-nowrap m-0 p-0 border-bottom"
      style={{ width: 1110 }}
    >
      <div className="col-xl-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_TYPE}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_TYPE", e.target.value)
            }
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unselect")}
            </option>
            <option value="OT">Open Top</option>
            <option value="FR">Flat Rack</option>
          </select>
        </div>
      </div>
      <div className="col-xl-2 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <select
            className="text-center form-select bg-transparent border-0"
            value={item.sfc_SIZE}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_SIZE", e.target.value)
            }
          >
            <option value="">
              {t("schedule.fcl.reserveNamsung.containerInfo.unselect")}
            </option>
            <option value="20">20`</option>
            <option value="40">40`</option>
            <option value="4H">40`HQ</option>
            <option value="45">45`</option>
          </select>
        </div>
      </div>

      <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="number"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t("schedule.fcl.reserveNamsung.containerInfo.enter")}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_LENGTH", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="number"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t("schedule.fcl.reserveNamsung.containerInfo.enter")}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_WIDTH", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="number"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t("schedule.fcl.reserveNamsung.containerInfo.enter")}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_HEIGHT", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="text"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t("schedule.fcl.reserveNamsung.containerInfo.enter")}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_VOID", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-xl-1 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="number"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t("schedule.fcl.reserveNamsung.containerInfo.enter")}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_WEIGHT", e.target.value)
            }
          />
        </div>
      </div>
      <div className="col-xl-3 flex-grow-1 text-center border-right m-0 p-0 d-flex flex-column">
        <div className="bg-light p-2 flex-fill d-flex flex-column align-items-center justify-content-center">
          <input
            type="text"
            className="bg-transparent border-0 text-center w-100"
            placeholder={t(
              "schedule.fcl.reserveNamsung.containerInfo.requestMemoPlaceholder"
            )}
            onChange={(e) =>
              changeContainerDetailData(index, "sfc_MEMO", e.target.value)
            }
          />
        </div>
      </div>
    </div>
  );
});

//안내 문구 모달
const NoteModal = (props) => {
  const { setIsModalOpen } = props;
  const { t } = useTranslation();
  return (
    <div className="modal_background">
      <div
        className="modal_body bg-white p-3 rounded-lg"
        style={{ maxWidth: 400 }}
      >
        <p className="h6 mb-0 font-weight-bold">{note_modal_data.title}</p>
        <p className="mb-2 text-secondary">{note_modal_data.desc}</p>
        <div className="text-right">
          <button
            className="btn btn-sm btn-primary bg-freiscop border-freiscop"
            onClick={() => setIsModalOpen(false)}
          >
            {t("schedule.fcl.reserveNamsung.check")}
          </button>
        </div>
      </div>
    </div>
  );
};
